import { render, staticRenderFns } from "./FetchingError.vue?vue&type=template&id=4d229038&scoped=true&"
import script from "./FetchingError.vue?vue&type=script&lang=js&"
export * from "./FetchingError.vue?vue&type=script&lang=js&"
import style0 from "./FetchingError.vue?vue&type=style&index=0&id=4d229038&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d229038",
  null
  
)

export default component.exports